<template>
  <div class="container">
    <div class="container-top">
      <img :src="this.publicData.serverUrl + 'images/sta.png'" alt="" />
    </div>
    <div class="container-classify">
      <el-select v-model="classify" placeholder="请选择">
        <el-option
          v-for="item in classifys"
          :key="item.label"
          v-show="item.id !== classify"
          :label="item.label"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="main">
      <div class="main-item" v-for="item in productions" :key="item.id">
        <img :src="item.cover" @click="handleView(item)" alt="" />
        <div class="main-item-info">
          <div class="main-item-info-status">
            <div class="main-item-info-status-item">
              <span class="tc-1">{{ item.title }}</span>
            </div>
            <div class="main-item-info-status-item view">
              <i class="el-icon-view"></i>
              {{ item.view }}
            </div>
          </div>
        </div>
      </div>
      <el-empty v-if="!productions.length" description="暂无数据！"></el-empty>
    </div>
  </div>
</template>

<script>
import { architectures } from '@/api/index'
import { viewProduction } from '@/api/personalCenter/index'
export default {
  name: 'simulation',
  components: {},
  props: [],
  data() {
    return {
      classify: this.$t('lang.external.fzsy.全部分类'),
      classifys: [],
      productions: [],
    }
  },
  watch: {
    classify() {
      this.getProductions()
    },
  },
  computed: {},
  created() {
    this.getProductions()
  },
  mounted() {},
  methods: {
    getProductions() {
      const productions = []
      architectures().then((res) => {
        const { data } = res.data.models
        data.forEach((v, i) => {
          productions.push({
            id: v.id,
            cover: v.cover,
            title: v.title,
            photo: v.user.userLogo,
            name: v.user.userNickName,
            path: v.show,
            view: v.view_count,
          })
        })
        this.productions = productions
      })
    },
    async handleView(val) {
      await viewProduction(val.id)
        .then((res) => {
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
      let url = decodeURIComponent(val.path)
      window.location.href = url
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  color: #666666;
  p {
    margin: 0;
  }
  &-top {
    height: 40vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-classify {
    width: 100%;
    padding: 0 18%;
    background-color: white;
    ::v-deep .el-input__inner {
      border: none;
      color: #666666;
      font-size: 0.9375vw;
    }
  }
  .main {
    width: 100%;
    padding: 20px 18%;
    display: flex;
    flex-flow: wrap;
    &-item {
      width: calc(25% - 20px);
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      margin-top: 20px;
      color: #666666;
      background: #ffffff;
      box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
      border-radius: 10px;
      &:first-child {
        margin-left: 0;
      }
      img {
        width: 100%;
        height: 12rem;
        border-radius: 10px 10px 0px 0px;
        cursor: pointer;
      }
      &-info {
        p {
          padding: 10px 15px;
          color: #666666;
        }
        &-rate {
          display: flex;
          padding: 10px 15px;
          padding-top: 0;
        }
        &-status {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #d7d7d7;
          color: #999999;
          &-item {
            // width: 50%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 10px 15px;
            i {
              font-size: large;
              margin-right: 5px;
            }
          }
          .view {
            flex-shrink: 0;
          }
        }
      }
    }
    .el-empty {
      width: 100%;
      height: 36vh;
    }
  }
}
::v-deep .el-select-dropdown__list {
  background-color: #f8f8f8;
}
::v-deep .el-select-dropdown__item {
  color: #666666;
  font-size: 0.9375vw;
  height: 45px;
  box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
}
::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #ffffff !important;
  background-color: #a63528 !important;
}
::v-deep .el-select .el-input .el-select__caret {
  color: #0c5893;
  font-weight: bold;
}
</style>